(() => {
  const videoObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting && video.paused) {
          video.setAttribute("preload", "auto");
          video.play().catch(() => {});
          videoObserver.unobserve(video);
        }
      }
    },
    { rootMargin: "200px" }
  );

  const initLazyVideos = (container = document) => {
    for (const video of container.querySelectorAll(".clp-banner-video:not([data-video-observed])")) {
      video.dataset.videoObserved = "true";
      videoObserver.observe(video);
    }
  };

  const initBannerSlider = (container = document, attempt = 0) => {
    if (typeof window.Swiper !== "function") {
      // ponytail: Swiper is defer-loaded; retry only while init runs, not via body MutationObserver
      if (attempt < 40) setTimeout(() => initBannerSlider(container, attempt + 1), 50);
      return;
    }

    for (const swiperEl of container.querySelectorAll(".banner-media-swiper:not([data-swiper-initialized])")) {
      swiperEl.dataset.swiperInitialized = "true";

      const slideLinks =
        swiperEl.dataset.slideLinks && swiperEl.dataset.slideLinks.trim() ? JSON.parse(swiperEl.dataset.slideLinks) : [];
      const slideLinkTexts =
        swiperEl.dataset.slideLinkTexts && swiperEl.dataset.slideLinkTexts.trim()
          ? JSON.parse(swiperEl.dataset.slideLinkTexts)
          : [];

      const parentContainer = swiperEl.closest("div.relative");
      const bannerLink = parentContainer?.querySelector(".banner-link");
      const bannerLinkText = bannerLink?.querySelector(".banner-link-text");

      const syncBannerLink = (realIndex) => {
        if (slideLinks[realIndex] && bannerLink) {
          bannerLink.href = slideLinks[realIndex];
        }
        if (slideLinkTexts[realIndex] && bannerLinkText) {
          bannerLinkText.textContent = slideLinkTexts[realIndex];
        }
      };

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      });

      syncBannerLink(swiper.realIndex);
      swiper.on("slideChange", () => syncBannerLink(swiper.realIndex));
    }
  };

  const init = (container = document) => {
    initBannerSlider(container);
    initLazyVideos(container);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init((event.target) || document);
  });

  window.BannerSlider = {
    init,
    initLazyVideos,
  };
})();
